import React from 'react';
import { SAMSNaturalMortalityMASlider } from '../common/SliderControls/SliderControls';
import type { RegistryComponentProps } from '../../pages/registry/componentRegistry';
import { getRegistryData } from '../../pages/registry/componentRegistry';
import { useFormContextOptional } from '../../contexts/FormContext';

const SLUG = 'scallop-natural-mortality-ma';

interface ScallopNaturalMortalityMAData {
  samsNaturalMortalityMA?: number;
  dbSamsNaturalMortalityMA?: number;
  updatingParams?: boolean;
}

export default function ScallopNaturalMortalityMA(props: RegistryComponentProps): React.ReactElement {
  const formContext = useFormContextOptional();
  const data = getRegistryData<ScallopNaturalMortalityMAData>(props);

  const dbSamsNaturalMortalityMA = data.dbSamsNaturalMortalityMA ?? 0.25;
  const formValue = formContext?.values?.[SLUG] as number | undefined;
  const samsNaturalMortalityMA =
    formValue ?? data.samsNaturalMortalityMA ?? dbSamsNaturalMortalityMA ?? 0.25;

  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = parseFloat(e.target.value);
      formContext?.setValue(SLUG, newValue);
    },
    [formContext]
  );

  return (
    <SAMSNaturalMortalityMASlider
      samsNaturalMortalityMA={samsNaturalMortalityMA}
      dbSamsNaturalMortalityMA={dbSamsNaturalMortalityMA}
      handleNaturalMortalityMAChange={handleChange}
      updatingParams={data.updatingParams ?? false}
    />
  );
}
